import React, { useState, useEffect } from "react";
import "./Events.css";
import AOS from "aos";
import "aos/dist/aos.css";

// ANNUAL IMAGES
import a2 from "../assets/annual2.JPG";
import a3 from "../assets/annual16.jpeg";
import a4 from "../assets/annual17.jpeg";
import a6 from "../assets/annual6.JPG";
import a7 from "../assets/annual7.JPG";
import a10 from "../assets/annual10.JPG";
import a11 from "../assets/annual11.JPG";
import a12 from "../assets/annual12.JPG";
import al1 from "../assets/annual-logo1.jpg";
import al2 from "../assets/annual-logo2.jpeg";

/* CONVOCATION */
import c1 from "../assets/convocation1.jpg";
import c2 from "../assets/convocation2.JPG";
import c3 from "../assets/convocation3.jpg";
import c4 from "../assets/convocation4.jpeg";
import c5 from "../assets/convocation5.jpeg";
import c6 from "../assets/convocation6.jpeg";

// AWARDS
import aw1 from "../assets/awards1.JPG";
import aw2 from "../assets/awards2.JPG";
import aw3 from "../assets/awards3.jpg";
import aw4 from "../assets/awards4.JPG";
import aw5 from "../assets/awards5.JPG";
import aw6 from "../assets/awards6.JPG";
import aw7 from "../assets/awards7.JPG";
import aw8 from "../assets/awards8.JPG";

// SCIENCE FAIR
import s1 from "../assets/science-fair1.jpeg";
import s2 from "../assets/science-fair2.jpeg";
import s3 from "../assets/science-fair3.jpeg";
import s5 from "../assets/science-fair5.JPG";
import sl1 from "../assets/science-fair-logo1.jpeg";
import sl3 from "../assets/science-fair-logo3.jpeg";

// CO-CURRICULAR & EXTRA-CURRICULAR
import y1 from "../assets/yoga-saroornagar1.jpeg";
import y2 from "../assets/yoga2.JPG";
import y3 from "../assets/yoga1.JPG";

import sp1 from "../assets/outdoor1.JPG";
import sp2 from "../assets/outdoor2.JPG";
import sp3 from "../assets/outdoor3.JPG";
import ind1 from "../assets/indoor1.jpeg";
import ind2 from "../assets/indoor2.jpeg";
import ind3 from "../assets/indoor3.jpeg";

import ab1 from "../assets/abacus1.JPG";
import ab2 from "../assets/abacus2.JPG";

import vm1 from "../assets/vedic1.jpeg";
import vm2 from "../assets/vedic2.jpeg";
import vm3 from "../assets/vedic3.JPG";

// FESTIVAL
import f1 from "../assets/festival1.jpeg";
import f2 from "../assets/christmas.jpeg";
import f3 from "../assets/bonalu.jpeg";
import f4 from "../assets/bathukamma.JPG";
import f5 from "../assets/diwali.JPG";
import f6 from "../assets/krishnastami.JPG";

const annualImages = [a2, a3, a4, a6, a7, a10, a11, a12, al1, al2];
const convoImages = [c1, c2, c3, c4, c5, c6];
const awardsImages = [aw1,aw2,aw3,aw4,aw5,aw6,aw7,aw8];
const scienceImages = [s1, s2, s3, s5, sl1, sl3];
const cocurricularCategories = {
  "Yoga Celebrations": [y1, y2, y3],
  "Sports Meet": {
    "Outdoor Games": [sp1, sp2, sp3],
    "Indoor Games": [ind1, ind2, ind3]
  },
  "Abacus": [ab1, ab2],
  "Vedic Maths": [vm1, vm2, vm3]
};
const festivalImages = [f1, f2, f3, f4, f5, f6];

function Events() {
  const [current, setCurrent] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeCategory, setActiveCategory] = useState("Yoga Celebrations");

  useEffect(() => {
    AOS.refresh();
  }, []);

  const nextSlide = () => {
    if (current < annualImages.length - 3) {
      setCurrent(current + 1);
    }
  };

  const prevSlide = () => {
    if (current > 0) {
      setCurrent(current - 1);
    }
  };

  return (
    <div className="events-page">

      <h1 className="main-title" data-aos="fade-up">
        Events at Lotus Lap Public School
      </h1>

      <p className="subtitle" data-aos="fade-up" data-aos-delay="100">
        Every moment at Lotus Lap is a celebration of learning, growth, and joy. 
        From vibrant cultural programs to meaningful milestones, our events create memories that last a lifetime.
      </p>

      {/* 🌟 ANNUAL DAY */}
      <section className="event-section">
        <h2 className="section-title" data-aos="fade-up">
          Annual Day Celebrations at Lotus Lap
        </h2>

        <p className="section-desc" data-aos="fade-up" data-aos-delay="100">
          A grand celebration of talent, creativity, and confidence.Our Annual Day brings together music, dance, drama, and vibrant performances where every child shines on stage and creates unforgettable memories.
        </p>

        <div className="carousel-wrapper" data-aos="zoom-in">
          <button className="nav-btn left" onClick={prevSlide}>‹</button>

          <div className="carousel-container">
            <div
              className="carousel-track"
              style={{ transform: `translateX(-${current * 33.33}%)` }}
            >
              {annualImages.map((img, index) => (
                <div className="carousel-card" key={index}>
                  <img
                    src={img}
                    alt="Annual Day"
                    onClick={() => setSelectedImage(img)}
                  />
                </div>
              ))}
            </div>
          </div>

          <button className="nav-btn right" onClick={nextSlide}>›</button>
        </div>
      </section>

      {/* CONVOCATION */}
      <section className="event-section">
        <h2 className="section-title" data-aos="fade-up">Convocation</h2>

        <p className="section-desc" data-aos="fade-up" data-aos-delay="100">
          A proud and emotional milestone at Lotus Lap, 
          our Convocation ceremony celebrates the journey of young learners stepping into new beginnings.
          It honors the little graduates of UKG as they move towards primary school, applauds students transitioning from 
          Grade 5 to middle school, and recognizes the achievements of Grade 10 students as they prepare to embrace the next chapter of their
          academic journey.
          A moment of pride, growth, and new aspirations.
        </p>

        <div className="image-grid">
          {convoImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt="Convocation"
              data-aos="zoom-in"
              data-aos-delay={index * 100}
              onClick={() => setSelectedImage(img)}
            />
          ))}
        </div>
      </section>

      {/* AWARDS */}
      <section className="event-section awards-section">
        <h2 className="section-title" data-aos="fade-up">Awards & Achievements</h2>

        <p className="section-desc" data-aos="fade-up" data-aos-delay="100">
          Celebrating excellence and recognizing brilliance, our Awards section reflects the dedication, talent, and hard work of our students. Each achievement is a proud moment for Lotus Lap, inspiring every learner to strive for greatness and shine with confidence.
        </p>

        <div className="awards-grid">
          {awardsImages.map((img, index) => (
            <div
              className="award-card"
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <img
                src={img}
                alt="Awards"
                onClick={() => setSelectedImage(img)}
              />
            </div>
          ))}
        </div>
      </section>

      {/* 🎉 FESTIVAL CELEBRATIONS */}
      <section className="event-section festival-section">
        <h2 className="section-title" data-aos="fade-up">
          Festival Celebrations at LotusLap.in
        </h2>

        <p className="section-desc" data-aos="fade-up" data-aos-delay="100">
          Festivals at Lotus Lap are filled with joy, colors, culture, and togetherness. 
          Through vibrant celebrations, students learn the values of unity, tradition, and respect for diverse cultures while creating beautiful memories with friends and teachers.
        </p>

        <div className="festival-grid">
          {festivalImages.map((img, index) => (
            <div
              className="festival-card"
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <img
                src={img}
                alt="Festival Celebrations"
                onClick={() => setSelectedImage(img)}
              />
            </div>
          ))}
        </div>
      </section>

      {/* SCIENCE FAIR */}
      <section className="event-section science-section">
        <h2 className="section-title" data-aos="fade-up">Science Fair</h2>

        <p className="section-desc" data-aos="fade-up" data-aos-delay="100">
          A platform where curiosity meets creativity, our Science Fair encourages young minds to explore, experiment, and innovate. Students showcase their ideas through models, projects, and experiments, transforming learning into an exciting journey of discovery and imagination.
        </p>

        <div className="science-scroll">
          {scienceImages.map((img, index) => (
            <div
              className="science-card"
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <img
                src={img}
                alt="Science"
                onClick={() => setSelectedImage(img)}
              />
            </div>
          ))}
        </div>

        <div className="swipe-hint" data-aos="fade-left">
          Swipe to see more →
        </div>
      </section>

      {/* 🏅 CO-CURRICULAR & EXTRA-CURRICULAR ACTIVITIES */}
      <section className="event-section cocurricular-section">
        <h2 className="section-title" data-aos="fade-up">
          Co-Curricular & Extra-Curricular Activities
        </h2>

        <p className="section-desc" data-aos="fade-up" data-aos-delay="100">
          At Lotus Lap Public School, we believe in nurturing all-round development. Our rich array of co-curricular and extra-curricular activities encourages students to explore their talents, build critical thinking skills, and foster a healthy physical and mental lifestyle.
        </p>

        {/* Tab Navigation */}
        <div className="category-tabs" data-aos="fade-up" data-aos-delay="150">
          {Object.keys(cocurricularCategories).map((category) => (
            <button
              key={category}
              className={`category-tab ${activeCategory === category ? "active" : ""}`}
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Category Images Grid */}
        <div className="cocurricular-grid-container">
          {activeCategory === "Sports Meet" ? (
            <>
              {/* Outdoor Games */}
              <h3 className="cocurricular-subheading" data-aos="fade-up">Outdoor Games</h3>
              <div className="cocurricular-grid">
                {cocurricularCategories["Sports Meet"]["Outdoor Games"].map((img, index) => (
                  <div
                    className="cocurricular-card"
                    key={`outdoor-${index}`}
                    data-aos="zoom-in"
                    data-aos-delay={index * 100}
                  >
                    <img
                      src={img}
                      alt={`Outdoor Games ${index + 1}`}
                      onClick={() => setSelectedImage(img)}
                    />
                  </div>
                ))}
              </div>

              {/* Indoor Games */}
              <h3 className="cocurricular-subheading" data-aos="fade-up" style={{ marginTop: "40px" }}>Indoor Games</h3>
              <div className="cocurricular-grid">
                {cocurricularCategories["Sports Meet"]["Indoor Games"].map((img, index) => (
                  <div
                    className="cocurricular-card"
                    key={`indoor-${index}`}
                    data-aos="zoom-in"
                    data-aos-delay={index * 100}
                  >
                    <img
                      src={img}
                      alt={`Indoor Games ${index + 1}`}
                      onClick={() => setSelectedImage(img)}
                    />
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="cocurricular-grid">
              {cocurricularCategories[activeCategory].map((img, index) => (
                <div
                  className="cocurricular-card"
                  key={`${activeCategory}-${index}`}
                  data-aos="zoom-in"
                  data-aos-delay={index * 100}
                >
                  <img
                    src={img}
                    alt={`${activeCategory} ${index + 1}`}
                    onClick={() => setSelectedImage(img)}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* 🔍 LIGHTBOX */}
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <span className="close-btn">×</span>

          <img
            src={selectedImage}
            alt="Full View"
            className="lightbox-img"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

    </div>
  );
}

export default Events;